import React from 'react';
import './PetAnimations.css';

export default function GoatSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#C8C0B8';
  const lightColor = color ? lighten(color) : '#E0D8D0';
  const darkColor = color ? darken(color) : '#A8A098';
  const hornColor = '#8B7B60';
  const beardColor = '#A09888';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail (short, upward) */}
      <path d="M86 62C90 58 92 54 90 52" stroke={bodyColor} strokeWidth="4" strokeLinecap="round" fill="none" />
      {/* Body */}
      <ellipse cx="60" cy="68" rx="28" ry="22" fill={bodyColor} />
      {/* Belly */}
      <ellipse cx="60" cy="74" rx="16" ry="12" fill={lightColor} />
      {/* Legs (sturdy) */}
      <rect x="38" y="84" width="8" height="16" rx="3" fill={bodyColor} />
      <rect x="50" y="86" width="7" height="14" rx="3" fill={bodyColor} />
      <rect x="64" y="86" width="7" height="14" rx="3" fill={bodyColor} />
      <rect x="76" y="84" width="8" height="16" rx="3" fill={bodyColor} />
      {/* Hooves */}
      <rect x="37" y="98" width="10" height="3" rx="1.5" fill="#4A4A4A" />
      <rect x="49" y="98" width="9" height="3" rx="1.5" fill="#4A4A4A" />
      <rect x="63" y="98" width="9" height="3" rx="1.5" fill="#4A4A4A" />
      <rect x="75" y="98" width="10" height="3" rx="1.5" fill="#4A4A4A" />
      {/* Head */}
      <ellipse cx="40" cy="44" rx="18" ry="16" fill={bodyColor} />
      {/* Curved horns */}
      <path d="M30 32C26 22 20 16 18 18C16 20 20 28 26 34" stroke={hornColor} strokeWidth="4" strokeLinecap="round" fill="none" />
      <path d="M50 32C54 22 60 16 62 18C64 20 60 28 54 34" stroke={hornColor} strokeWidth="4" strokeLinecap="round" fill="none" />
      {/* Ears */}
      <ellipse cx="22" cy="40" rx="7" ry="3.5" fill={bodyColor} transform="rotate(-25 22 40)" />
      <ellipse cx="58" cy="40" rx="7" ry="3.5" fill={bodyColor} transform="rotate(25 58 40)" />
      <ellipse cx="22" cy="40" rx="4.5" ry="2" fill="#E8A0A0" transform="rotate(-25 22 40)" />
      <ellipse cx="58" cy="40" rx="4.5" ry="2" fill="#E8A0A0" transform="rotate(25 58 40)" />
      {/* Muzzle */}
      <ellipse cx="36" cy="50" rx="10" ry="8" fill={lightColor} />
      {/* Eyes (rectangular pupils!) */}
      <circle cx="32" cy="42" r="3.5" fill="#E8D890" />
      <circle cx="48" cy="42" r="3.5" fill="#E8D890" />
      <rect x="30.5" y="40.5" width="4" height="3" rx="0.5" fill="#1A1A1A" />
      <rect x="46.5" y="40.5" width="4" height="3" rx="0.5" fill="#1A1A1A" />
      <circle cx="33" cy="41" r="0.7" fill="white" />
      <circle cx="49" cy="41" r="0.7" fill="white" />
      {/* Nose */}
      <circle cx="33" cy="49" r="1.5" fill={darkColor} />
      <circle cx="39" cy="49" r="1.5" fill={darkColor} />
      {/* Mouth */}
      <path d="M33 53C35 55 39 55 41 53" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      {/* Beard tuft */}
      <path d="M34 56C34 60 32 66 30 68" stroke={beardColor} strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M36 56C36 62 35 68 34 70" stroke={beardColor} strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M38 56C38 60 38 66 38 68" stroke={beardColor} strokeWidth="2" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
